import React from 'react';
import isEmpty from 'helpers/isEmpty';
import { getProfile } from 'auth';
import OrderServices from 'modules/order/services/OrderServices';
import routesPath from 'config/routesPath';
import { PROFILES } from 'constants/profiles';
import RenderLoadingAuthentication from 'components/RenderLoadingAuthentication';
import getRoutes from './components/getRoutes';
import buildRoutes from './components/buildRoutes';
import defineProfile from './components/defineProfile';
import { checkCallCenterOsSearchAndRescueRoute } from 'helpers/checkCallcenterOrSearchAndRescue';
import { DealerFromStore } from 'components/withDealer';
import { SocketProvider } from 'socketContext';
class MainContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isConsultantUser: false,
      isWithoutDealer: false,
    };
  }

  async componentDidMount() {
    this.setState({ isLoading: true });
    const {
      userStore: { email, setUserProfile },
    } = this.props;

    const userSiteId = await this.getMeInfos();
    this.props.setUserSiteId(userSiteId);
    const userProfile = this.getUserProfile(email, setUserProfile);
    const isConsultantUser = this.isConsultantUser(userProfile);
    this.props.setCurrentUser({
      ...(await getProfile()),
      userProfile,
    });
    this.setState({ isConsultantUser });
    this.props.dealerStore.setProfile(
      isConsultantUser ? PROFILES.CONSULTOR : PROFILES.USER
    );

    if (window.location.pathname.includes('checkAndRedirect')) {
      this.setState({ isLoading: false });
      return;
    }

    await this.redirectToMainPage(isConsultantUser);

    this.setState({ isLoading: false });
  }

  async getMeInfos() {
    try {
      const { data, success } = await OrderServices.getMeInfo();
      if (success) {
        return data?.id;
      }
    } catch {
      console.error('error');
    }
  }

  redirectToMainPage = async isConsultantUser => {
    if (checkCallCenterOsSearchAndRescueRoute()) {
      return;
    }

    const {
      dealerStore: {
        getDealers,
        getAllDealersByUser,
        setDealerObserved,
        getCadastro,
      },
      userStore: { attributes },
    } = this.props;

    const dealerLocalStorage = DealerFromStore.getDealerFromLocalStorage();

    //LOCAL_STORAGE_EMPTY
    if (isEmpty(dealerLocalStorage)) {
      const dealersList = await getDealers();
      if (dealersList?.length === 1 && dealersList?.[0].id) {
        window.location.href = routesPath.getRecursivePath(
          routesPath.mobigestorHome,
          { dealerId: dealersList?.[0].id }
        );
        return;
      }
      this.props.history.push(routesPath.myResellers);
      return;
    }

    if (dealerLocalStorage?.id !== this.props.match.params?.dealerId) {
      dealerLocalStorage.id = this.props.match.params.dealerId;
    }

    setDealerObserved(dealerLocalStorage);

    //IF_CURRENT_USER_IS_CONSULTANT
    if (isConsultantUser) {
      await getAllDealersByUser();
      const cadastro = await getCadastro();
      if (!cadastro) {
        this.props.history.push(routesPath.myResellers);
        return;
      }
      const dealerObj = { ...dealerLocalStorage, ...cadastro };
      this.props.getCurrentUserInfosByDealerId(dealerObj.id);
      this.props.setCurrentDealer(dealerObj);
      return;
    }

    //USERS_SET_DEALER
    const dealersList = await getDealers();
    const cadastro = await getCadastro(dealerLocalStorage?.id);
    if (!cadastro) {
      if (dealersList?.length === 1 && dealersList?.[0].id) {
        window.location.href = routesPath.getRecursivePath(
          routesPath.mobigestorHome,
          { dealerId: dealersList?.[0].id }
        );
        return;
      }
      this.props.history.push(routesPath.myResellers);
      return;
    }
    const dealerObj = {
      ...dealerLocalStorage,
      ...cadastro,
    };
    this.props.getCurrentUserInfosByDealerId(dealerObj.id);
    this.props.setCurrentDealer(dealerObj);

    //IF USER HAVE CALLCENTER ATTRIBUTE REDIRECTO TO CALL CENTER
    if (!isEmpty(attributes?.callcenter)) {
      DealerFromStore.setDealerGroupToLocalStorage({
        id: attributes.callcenter[0],
        name: '',
        active: true,
      });
      this.props.history.push(routesPath.callCenter);
    }

    //IF WITHOUT DEALER REDIRECT TO WELCOME PAGE
    if (isEmpty(this.props.dealerStore.dealers)) {
      this.setState({ isWithoutDealer: true });
      this.props.history.push(routesPath.welcome);
    }
  };

  isConsultantUser = userProfile => {
    return userProfile === PROFILES.CONSULTOR;
  };

  getUserProfile = (email, setUserProfile) => {
    const userProfile = defineProfile(email);

    setUserProfile(userProfile);
    return userProfile;
  };

  render() {
    if (this.state.isLoading) {
      return <RenderLoadingAuthentication />;
    }
    const ViewComponent = this.props.viewComponent;

    const {
      dealerStore: { products },
    } = this.props;

    const hasMobioOneProduct =
      !isEmpty(products) &&
      products.some(product => product.type === 'MOBIONE');

    const hasResaleBuyProduct =
      !isEmpty(products) &&
      products.some(product => product.type === 'REPASSE');

    const hasResaleSellProduct =
      !isEmpty(products) &&
      products.some(product => product.type === 'REPASSE_VENDA');

    const routes = getRoutes({
      isConsultant: this.state.isConsultantUser,
      hasDealer: !this.state.isWithoutDealer,
      hasResaleBuy: hasResaleBuyProduct,
      hasResaleSell: hasResaleSellProduct,
    });

    const buildedRoutes = buildRoutes(routes, this.state.isWithoutDealer);

    return (
      <SocketProvider>
        <ViewComponent
          {...this.props}
          routes={buildedRoutes}
          isWithoutDealer={this.state.isWithoutDealer}
          isInConsultantScreen={
            this.props.location.pathname === routesPath.myResellers
          }
          isConsultantUser={this.state.isConsultantUser}
          hasResaleSellProduct={hasResaleSellProduct}
          hasMobioOneProduct={hasMobioOneProduct}
        />
      </SocketProvider>
    );
  }
}

export default MainContainer;
